$('.video-section__btn').on('click', function (e) {
  //$('.article-video__content video')[0].play();

  $('.video-section iframe')[0].src += '&autoplay=1';
  $('.video-section').addClass('video-play');
  e.preventDefault();
  $(this).hide();
});

$('.video-section__play--desktop').on('click', function (e) {
  //$('.article-video__content video')[0].play();
  $('.video-section').addClass('video-play');
  $('.video-section video#video_desktop')[0].play();
  e.preventDefault();
  $(this).hide();
});

$('.video__modal--close').on('click', function (e) {
  e.preventDefault();
  $('body').removeClass('video-modal__active');
  $('.video-frame').attr('src', '');
});

$('.article-hero__video--link').on('click', function (e) {
  e.preventDefault();
  $('body').addClass('video-modal__active');
  var $parent = $(this).closest('.tutorials-main__item');
  var $frame = $parent.find('.video-frame');
  $parent.addClass('active').find('.tutorials-main__item.active').removeClass('active');
  $($(this).attr('href')).addClass('active');
  $frame.attr('src', $frame.attr('data-src'));
});
